import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  Switch,
} from "@blueprintjs/core";
import {
  MDBCol,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { observable } from "mobx";
import PhoneInput from "react-phone-input-2";

interface EmpresaCaixaPostalProps {
}

interface EmpresaCaixaPostalState {
  caixapostal_automatica: boolean;
}

@observer
export default class EmpresaCaixaPostal extends React.Component<EmpresaCaixaPostalProps, EmpresaCaixaPostalState> {

  obs = observable({
    open_modal_ecac: false as boolean,
  })

  constructor(props) {
    super(props);

    this.state = {
      caixapostal_automatica: EmpresaStore.obs.empresa_edit.caixapostal_automatica,
    };
  }

  handleChangeCaixapostal = (e) => {
    const newValue = e.target.checked;
    this.setState({ caixapostal_automatica: newValue });
    EmpresaStore.obs.empresa_edit.caixapostal_automatica = newValue;

    if (newValue) {
      this.obs.open_modal_ecac = true;
    }
  };

  render() {

    return (

      <>

        <div style={{ width: 1000 }}>

          <MDBCol md="12">
            {EmpresaStore.obs.empresa_edit.certificado
              ?
              <FormGroup label="Caixa Postal (RFB)">
                <Switch
                  className="select-regras"
                  label={EmpresaStore.obs.empresa_edit.caixapostal_automatica ? "Ativado" : "Desativado"}
                  checked={EmpresaStore.obs.empresa_edit.caixapostal_automatica}
                  onChange={(e: any) => this.handleChangeCaixapostal(e)} />
              </FormGroup>
              :
              <>
                <FormGroup label="Caixa Postal (RFB)">
                  <p>Cadastre o Certificado Digital para poder Ativar!</p>
                  <Switch
                    label="Desativado"
                    disabled
                    checked={false} />
                </FormGroup>
              </>
            }
          </MDBCol>

          {EmpresaStore.obs.empresa_edit.caixapostal_automatica && (
            <>
              <br />

              <MDBCol md="12">
                <Switch
                  label="Receber aviso de novas mensagens do Caixa Postal por WhatsApp"
                  alignIndicator="right"
                  checked={EmpresaStore.obs.empresa_edit.send_message_caixa_postal}
                  onChange={(e: any) => EmpresaStore.obs.empresa_edit.send_message_caixa_postal = e.target.checked}
                  style={{ width: "max-content", fontWeight: "bold" }}
                />
              </MDBCol>

              {EmpresaStore.obs.empresa_edit.send_message_caixa_postal ? (
                <MDBCol md="12">
                  <FormGroup helperText="Insira um número com DDD para receber as cópias das mensagens.">
                    <PhoneInput
                      country={'br'}
                      enableSearch
                      excludeCountries={['us', 'ua', 'ru']}
                      value={EmpresaStore.obs.empresa_edit.caixa_postal_numero}
                      onChange={phone => EmpresaStore.obs.empresa_edit.caixa_postal_numero = phone}
                      inputClass="phone-input"
                      searchClass="phone-input-search"
                      disableSearchIcon
                    />
                  </FormGroup>
                </MDBCol>
              ) : <br />}
            </>
          )}

        </div>

        <Dialog
          isOpen={this.obs.open_modal_ecac}
          title="Atenção!"
          onClose={() => this.obs.open_modal_ecac = false}
        >
          <div className={Classes.DIALOG_BODY}>

            <p>
              Para que o sistema FIPO possa realizar o monitoramento da Caixa Postal (RFB), é necessário que a empresa possua uma procuração devidamente outorgada no e-CAC.<br />

              <br />Lembramos que, após a liberação no e-CAC, o FIPO levará em torno de 1 dia para começar o monitoramento.<br />

              <br />Se tiver dúvidas sobre como cadastrar essa procuração no e-CAC, siga o passo a passo disponível em: <a href="https://help.fipo.com.br/paginas/caixa_postal" style={{ textDecoration: "none", color: "#007bff" }}>Cadastrar uma Procuração e-CAC</a>.<br />

              <br />Atenciosamente,<br />
              <br /><b>FIPO - CNPJ: 31.444.513/0001-15</b>
            </p>

          </div>

          <div className={Classes.DIALOG_FOOTER}>

            <div className={Classes.DIALOG_FOOTER_ACTIONS}>

              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_modal_ecac = false} />

            </div>

          </div>

        </Dialog>

      </>
    );
  }
}